import React from 'react'
import { IconEwiWarningTriangle } from 'components/Zui/Icon'
import { useIntl } from 'hooks'
import { ToggleSwitch, InlineMessage } from 'components/Zui'
import './index.css'

const Index = ({ isDownloadable, isAnonymized, setFieldValue, isShareFromCollection }) => {
    const { t } = useIntl()

    return (
        <div className="file-setting-wrapper">
            <div className="file-setting-form">
                <div className="form-label-row setting">
                    <span>{t('file.settings.label')}</span>
                </div>
                <div className="file-setting-toggle-wrapper">
                    {!isShareFromCollection && (
                        <div className="toggle-input">
                            <ToggleSwitch
                                name="isAnonymized"
                                value={isAnonymized}
                                size="s"
                                onChange={e => {
                                    setFieldValue('isAnonymized', e.target.value)
                                }}
                                required
                            />
                            <span>{t('anonymize.data.text')}</span>
                        </div>
                    )}
                    {!isAnonymized && (
                        <div className="annonymized-message">
                            <InlineMessage>
                                {t('disclaimer.annonymized.text')}
                                <IconEwiWarningTriangle slot="icon" />
                            </InlineMessage>
                        </div>
                    )}
                    <div className="toggle-input">
                        <ToggleSwitch
                            size="s"
                            name="isDownloadable"
                            value={isDownloadable}
                            onChange={e => {
                                setFieldValue('isDownloadable', e.target.value)
                            }}
                            required
                        />
                        <span>{t('allow.download.text')}</span>
                    </div>
                    {!isDownloadable && (
                        <div className="annonymized-message">
                            <InlineMessage>
                                {t('disclaimer.download.text')}
                                <IconEwiWarningTriangle slot="icon" />
                            </InlineMessage>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default React.memo(Index)
